'use client';

import { useEffect, useLayoutEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useGetUser } from '@/queries/user';
import formbricks from '@formbricks/js';

export default function FormbricksProvider() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const { data: user } = useGetUser({ enabled: false });

  const [isFormbricksInitialized, setIsFormbricksInitialized] =
    useState<boolean>(false);

  useLayoutEffect(() => {
    const environmentId = process.env.NEXT_PUBLIC_FORMBRICKS_ENVIRONMENT_ID;
    const apiHost = process.env.NEXT_PUBLIC_FORMBRICKS_API_HOST;

    const isFormbricksApiConfigured = !!environmentId && !!apiHost;

    if (typeof window !== 'undefined' && isFormbricksApiConfigured) {
      formbricks
        .init({
          environmentId,
          apiHost,
          userId: user?.nationalId,
          attributes: {
            language: 'persian',
            ...(user?.email && { email: user?.email }),
            ...(user?.displayName && { displayName: user?.displayName }),
            ...(user?.phoneNumber && { phoneNumber: user?.phoneNumber }),
          },
        })
        .then(() => {
          setIsFormbricksInitialized(true);
        });
    }
  }, [user]);

  useEffect(() => {
    if (isFormbricksInitialized) {
      formbricks?.registerRouteChange();
    }
  }, [pathname, searchParams, isFormbricksInitialized]);

  return null;
}
